import Splide from "@splidejs/splide";

export default {
  init() {
    // JavaScript to be fired on the home page
    console.log('testing');
    Fancybox.bind('[data-fancybox="testimonial_main_item"]', {
      Thumbs: {
        Carousel: {
          fill: false,
          center: true,
        },
      },
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
